<template>
  <div class="page-wrapper login">
    <template
      v-if="page === 'login-form'">
      <div class="page-content">
        <LoginForm @forgotPass="page = 'forgot-pass'" />
      </div>
      <div class="page-slider">
        <slick
          :options="sliderOptions"
          @init="handleSliderInit">
          <img :src="sliderImages.first[projectTheme]">
          <img src="@/assets/images/login/login-slider-image-2.png">
          <img :src="sliderImages.third[projectTheme]">
        </slick>
        <div class="slider-captions">
          <div class="slider-caption-title">
            {{ sliderMsgs[slider.currentSlide || 0].title }}
          </div>
          <div class="slider-caption-description">
            {{ sliderMsgs[slider.currentSlide || 0].description }}
          </div>
        </div>
      </div>
    </template>
    <template
      v-else-if="page === 'forgot-pass'">
      <div class="page-content">
        <LoginForgotPassForm @login="page = 'login-form'" />
      </div>
      <img
        src="@/assets/images/reset-password.svg"
        class="page-image">
    </template>
  </div>
</template>

<script>
import sliderImage1Build from '@/assets/images/login/login-slider-image-1-build.png';
import sliderImage1New from '@/assets/images/login/login-slider-image-1-new.png';
import sliderImage1Rent from '@/assets/images/login/login-slider-image-1-rent.png';
import sliderImage1Sale from '@/assets/images/login/login-slider-image-1-sale.png';
import sliderImage1Invest from '@/assets/images/login/login-slider-image-1-invest.png';
import sliderImage3Build from '@/assets/images/login/login-slider-image-3-build.png';
import sliderImage3New from '@/assets/images/login/login-slider-image-3-new.png';
import sliderImage3Rent from '@/assets/images/login/login-slider-image-3-rent.png';
import sliderImage3Sale from '@/assets/images/login/login-slider-image-3-sale.png';
import sliderImage3Invest from '@/assets/images/login/login-slider-image-3-invest.png';
import LoginForm from '@/components/login/LoginForm.vue';
import LoginForgotPassForm from '@/components/login/LoginForgotPassForm.vue';

export default {
  name: 'Login',
  components: {
    LoginForm,
    LoginForgotPassForm,
  },
  data() {
    return {
      page: 'login-form',
      sliderImages: {
        first: {
          build: sliderImage1Build,
          new: sliderImage1New,
          rent: sliderImage1Rent,
          sale: sliderImage1Sale,
          invest: sliderImage1Invest,
        },
        third: {
          build: sliderImage3Build,
          new: sliderImage3New,
          rent: sliderImage3Rent,
          sale: sliderImage3Sale,
          invest: sliderImage3Invest,
        },
      },
      slider: {},
      sliderOptions: {
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        useTransform: false,
      },
    };
  },
  computed: {
    projectTheme() {
      return this.$store.getters.projectTheme;
    },
    sliderMsgs() {
      return [
        {
          title: this.$options.filters.translate('admin_login_slide_1_title'),
          description: this.$options.filters.translate('admin_login_slide_1_description'),
        },
        {
          title: this.$options.filters.translate('admin_login_slide_2_title'),
          description: this.$options.filters.translate('admin_login_slide_2_description'),
        },
        {
          title: this.$options.filters.translate('admin_login_slide_3_title'),
          description: this.$options.filters.translate('admin_login_slide_3_description'),
        },
      ];
    },
  },
  beforeCreate() {
    if (!this.$store.state.bootstrap || !Object.keys(this.$store.state.bootstrap).length) {
      // Will be called after logout
      this.$store.dispatch('getInitAppData', this.$route).catch(this.showResponseError);
    }
  },
  methods: {
    handleSliderInit(event, slider) {
      this.slider = slider;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  margin-top: -167px;

  ::v-deep {
    .page-description {
      padding-top: 0 !important;
    }

    .login-content-link {
      color: $color-theme;
      padding-bottom: 30px;
    }

    .login-row-space {
      padding-bottom: 24px;
    }

    .validation-msg {
      margin-bottom: 24px;
    }
  }
}

.page-slider {
  margin-bottom: 95px; // because dots absolute position -95px

  .slick-slider {
    &.slick-dotted {
      margin-bottom: 20px;
    }

    ::v-deep {
      .slick-list {
        padding: 0 !important;
      }

      .slick-slide {
        img {
          width: auto !important;
          max-height: 440px;
        }
      }
    }
  }

  .slider-captions {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 0px;

    .slider-caption-title {
      font-size: 16px;
      font-weight: $font-weight-bold;
      padding-bottom: 2px;
    }

    .slider-caption-description {
      font-size: 14px;
    }
  }

  ::v-deep {
    .slick-dots {
      bottom: -95px;
    }
  }
}

@media only screen and (max-width: 1159px) {
  .page-slider {
    .slick-slider {
      ::v-deep {
        .slick-slide {
          img {
            width: 100% !important;
            height: auto;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .page-content {
    margin-top: 0;
  }

  .page-slider {
    margin-bottom: 61px !important;
  }
}
</style>
